<template>
    <FormsCard v-if="init">
      <img class="block mx-auto mb-6 w-32 sm:w-40 h-auto" src="@/assets/omind_logo.png" alt="test">
      <h2 class="text-center pb-5 text-xl sm:text-2xl">
          {{ getMessage }}</h2>
      <i class="text-9xl text-center mt-4">
          <font-awesome-icon v-if="!hasError" icon="fa-circle-check"
            class="text-[var(--color-orange)]"/>
          <font-awesome-icon v-else icon="fa-ban" class="text-[var(--color-error)]"/>
      </i>
      <router-link to="/auth" name="verify" id="btn_verify"
          class="btn-primary-accent mt-8 sm:mt-12 w-full sm:w-auto px-6 py-2.5 sm:px-12 sm:py-3 text-base sm:text-xl mx-auto block text-center min-h-[2.75rem] text-white no-underline">
          {{ $t('ActivateAccountComponent.goToLogin') }}
      </router-link>
    </FormsCard>
</template>
<script>
import FormsCard from '../global/slots/FormsCard.vue';

export default {
  props: ['email', 'validationKey'],
  name: 'ActivateAccountComponent',
  components: { FormsCard },
  data() {
    return {
      init: false,
      hasError: false,
      message: null,
    };
  },
  computed: {
    getMessage() {
      return this.message;
    },
  },
  methods: {
    async activateUser() {
      try {
        if (!(this.email && this.validationKey)) {
          this.message = this.$t('ActivateAccountComponent.invalidUrl');
          this.hasError = true;
          this.init = true;
          return;
        }
        await this.$store.dispatch('activateAccount', {
          email: this.email,
          validationKey: this.validationKey,
        });
        this.message = this.$t('ActivateAccountComponent.accountActivated');
        this.init = true;
      } catch (error) {
        this.hasError = true;
        this.message = this.$t('ActivateAccountComponent.accountNotActivated');
        this.init = true;
      }
    },
  },
  mounted() {
    this.activateUser();
  },
};
</script>
